{
  "registryId": "safetyqr_reporting_templates",
  "registryVersion": "2026-03-29.phase4",
  "templates": [
    {
      "id": "safetyqr.report.vehicle_incident.v1",
      "displayName": "Vehicle incident report",
      "headline": "Report a vehicle incident",
      "helperText": "Share the minimum scene details responders need. No OTP is required before you submit.",
      "subjectSummary": {
        "title": "Vehicle incidents stay responder-focused",
        "description": "Use this flow for crashes, roadside hazards, breakdowns, theft attempts, or active vehicle scenes."
      },
      "confirmation": {
        "title": "Ready to send this vehicle report?",
        "body": "This lightweight confirmation replaces OTP for bystander submissions. Review the details, then send the report immediately.",
        "actionLabel": "Confirm and submit report"
      },
      "actions": [
        {
          "id": "report_incident",
          "label": "Report Incident",
          "description": "Share the structured vehicle incident details responders need.",
          "submissionMode": "confirm_before_submit",
          "submitLabel": "Review report before sending",
          "fieldIds": [
            "severity",
            "incidentType",
            "injuryStatus",
            "peopleInvolved",
            "delay",
            "reporterName",
            "reporterPhone",
            "reporterEmail",
            "locationDescription",
            "vehicleReference",
            "description",
            "policeAssistanceRequested",
            "ambulanceRequested"
          ],
          "requiredFieldIds": [
            "severity",
            "incidentType",
            "injuryStatus",
            "peopleInvolved",
            "reporterPhone",
            "locationDescription",
            "description"
          ],
          "confirmation": {
            "title": "Ready to send this vehicle report?",
            "body": "This lightweight confirmation replaces OTP for bystander submissions. Review the details, then send the report immediately.",
            "actionLabel": "Confirm and submit report"
          }
        }
      ],
      "media": {
        "allowVoiceNote": true,
        "maxPhotos": 4
      },
      "normalization": {
        "reportKind": "incident",
        "typeFieldId": "incidentType",
        "severityFieldId": "severity",
        "injuryStatusFieldId": "injuryStatus",
        "peopleInvolvedFieldId": "peopleInvolved",
        "delayFieldId": "delay",
        "locationDescriptionFieldId": "locationDescription",
        "reporterNameFieldId": "reporterName",
        "reporterPhoneFieldId": "reporterPhone",
        "reporterEmailFieldId": "reporterEmail",
        "descriptionFieldIds": [
          "vehicleReference",
          "description"
        ]
      },
      "fields": [
        {
          "id": "severity",
          "kind": "choice",
          "label": "Severity",
          "required": true,
          "options": [
            { "label": "Minor", "value": "minor" },
            { "label": "Moderate", "value": "moderate" },
            { "label": "Severe", "value": "severe" },
            { "label": "Critical", "value": "critical" }
          ],
          "defaultValue": ""
        },
        {
          "id": "incidentType",
          "kind": "select",
          "label": "Incident type",
          "required": true,
          "options": [
            { "label": "Accident", "value": "accident" },
            { "label": "Medical issue", "value": "medical" },
            { "label": "Fire or smoke", "value": "fire" },
            { "label": "Breakdown", "value": "breakdown" },
            { "label": "Theft or tampering", "value": "theft" },
            { "label": "Hazard nearby", "value": "hazard" }
          ],
          "defaultValue": "accident"
        },
        {
          "id": "injuryStatus",
          "kind": "select",
          "label": "Injury status",
          "required": true,
          "options": [
            { "label": "No known injuries", "value": "none-known" },
            { "label": "Possible injuries", "value": "possible" },
            { "label": "Serious injuries", "value": "serious" },
            { "label": "Unknown", "value": "unknown" }
          ],
          "defaultValue": "unknown"
        },
        {
          "id": "peopleInvolved",
          "kind": "select",
          "label": "People involved",
          "required": true,
          "options": [
            { "label": "Select", "value": "" },
            { "label": "1", "value": "1" },
            { "label": "2", "value": "2" },
            { "label": "3", "value": "3" },
            { "label": "4", "value": "4" },
            { "label": "5", "value": "5" },
            { "label": "6", "value": "6" },
            { "label": "7", "value": "7" },
            { "label": "8", "value": "8" }
          ],
          "defaultValue": ""
        },
        {
          "id": "delay",
          "kind": "select",
          "label": "Estimated delay",
          "required": false,
          "options": [
            { "label": "Select if known", "value": "" },
            { "label": "< 5 minutes", "value": "< 5 minutes" },
            { "label": "5-15 minutes", "value": "5-15 minutes" },
            { "label": "15-30 minutes", "value": "15-30 minutes" },
            { "label": "30-60 minutes", "value": "30-60 minutes" },
            { "label": "1-2 hours", "value": "1-2 hours" },
            { "label": "> 2 hours", "value": "> 2 hours" }
          ],
          "defaultValue": ""
        },
        {
          "id": "reporterName",
          "kind": "text",
          "label": "Your name",
          "required": false,
          "defaultValue": ""
        },
        {
          "id": "reporterPhone",
          "kind": "tel",
          "label": "Your phone",
          "required": true,
          "helperText": "Responders can use this if they need a quick callback.",
          "defaultValue": ""
        },
        {
          "id": "reporterEmail",
          "kind": "email",
          "label": "Your email",
          "required": false,
          "defaultValue": ""
        },
        {
          "id": "locationDescription",
          "kind": "text",
          "label": "Location details",
          "required": true,
          "helperText": "Share the road, landmark, lane, or nearby exit if GPS is limited.",
          "defaultValue": ""
        },
        {
          "id": "vehicleReference",
          "kind": "text",
          "label": "Vehicle reference",
          "required": false,
          "defaultValue": ""
        },
        {
          "id": "description",
          "kind": "textarea",
          "label": "Scene details",
          "required": true,
          "defaultValue": ""
        },
        {
          "id": "policeAssistanceRequested",
          "kind": "toggle",
          "label": "Police help is needed",
          "required": false,
          "helperText": "Store this escalation hint with the report even before authority routing is expanded.",
          "defaultValue": false
        },
        {
          "id": "ambulanceRequested",
          "kind": "toggle",
          "label": "Ambulance help is needed",
          "required": false,
          "defaultValue": false
        }
      ]
    },
    {
      "id": "safetyqr.report.rider_help_incident.v1",
      "displayName": "Rider help and incident report",
      "headline": "Report a rider safety issue",
      "helperText": "Keep this fast and mobile-friendly. No OTP is required before the report is submitted.",
      "subjectSummary": {
        "title": "Rider reports stay lightweight",
        "description": "Capture the issue, the rider condition, and where help is needed without the larger four-wheeler form."
      },
      "confirmation": {
        "title": "Send this rider report now?",
        "body": "This confirmation is the only friction step before bystander submission.",
        "actionLabel": "Confirm and send rider report"
      },
      "actions": [
        {
          "id": "report_incident",
          "label": "Report Incident",
          "description": "Send the lightweight rider help and incident report.",
          "submissionMode": "confirm_before_submit",
          "submitLabel": "Review report before sending",
          "fieldIds": [
            "severity",
            "issueType",
            "riderCondition",
            "locationDescription",
            "reporterPhone",
            "reporterName",
            "reporterEmail",
            "vehicleReference",
            "description",
            "policeAssistanceRequested",
            "ambulanceRequested"
          ],
          "requiredFieldIds": [
            "severity",
            "issueType",
            "riderCondition",
            "locationDescription",
            "reporterPhone",
            "description"
          ],
          "confirmation": {
            "title": "Send this rider report now?",
            "body": "This confirmation is the only friction step before bystander submission.",
            "actionLabel": "Confirm and send rider report"
          }
        }
      ],
      "media": {
        "allowVoiceNote": true,
        "maxPhotos": 4
      },
      "presentation": {
        "supportsDualLanguage": true,
        "localLanguageSelectionMode": "english_plus_selected_local"
      },
      "normalization": {
        "reportKind": "incident",
        "typeFieldId": "issueType",
        "severityFieldId": "severity",
        "injuryStatusFieldId": "riderCondition",
        "locationDescriptionFieldId": "locationDescription",
        "reporterNameFieldId": "reporterName",
        "reporterPhoneFieldId": "reporterPhone",
        "reporterEmailFieldId": "reporterEmail",
        "descriptionFieldIds": [
          "vehicleReference",
          "description"
        ]
      },
      "fields": [
        {
          "id": "severity",
          "kind": "choice",
          "label": "Severity",
          "required": true,
          "options": [
            { "label": "Minor", "value": "minor" },
            { "label": "Moderate", "value": "moderate" },
            { "label": "Severe", "value": "severe" },
            { "label": "Critical", "value": "critical" }
          ],
          "defaultValue": ""
        },
        {
          "id": "issueType",
          "kind": "select",
          "label": "Issue type",
          "required": true,
          "options": [
            { "label": "Crash or fall", "value": "accident" },
            { "label": "Breakdown or roadside help", "value": "breakdown" },
            { "label": "Unsafe location or hazard", "value": "hazard" },
            { "label": "Medical support needed", "value": "medical" },
            { "label": "Theft or tampering", "value": "theft" }
          ],
          "defaultValue": "accident"
        },
        {
          "id": "riderCondition",
          "kind": "select",
          "label": "Rider condition",
          "required": true,
          "options": [
            { "label": "Stable", "value": "stable" },
            { "label": "Possibly injured", "value": "possible_injury" },
            { "label": "Seriously injured", "value": "serious_injury" },
            { "label": "Unknown", "value": "unknown" }
          ],
          "defaultValue": "unknown"
        },
        {
          "id": "locationDescription",
          "kind": "text",
          "label": "Location details",
          "required": true,
          "defaultValue": ""
        },
        {
          "id": "reporterPhone",
          "kind": "tel",
          "label": "Your phone",
          "required": true,
          "defaultValue": ""
        },
        {
          "id": "reporterName",
          "kind": "text",
          "label": "Your name",
          "required": false,
          "defaultValue": ""
        },
        {
          "id": "reporterEmail",
          "kind": "email",
          "label": "Your email",
          "required": false,
          "defaultValue": ""
        },
        {
          "id": "vehicleReference",
          "kind": "text",
          "label": "Bike or rider reference",
          "required": false,
          "defaultValue": ""
        },
        {
          "id": "description",
          "kind": "textarea",
          "label": "What happened?",
          "required": true,
          "defaultValue": ""
        },
        {
          "id": "policeAssistanceRequested",
          "kind": "toggle",
          "label": "Police help is needed",
          "required": false,
          "defaultValue": false
        },
        {
          "id": "ambulanceRequested",
          "kind": "toggle",
          "label": "Ambulance help is needed",
          "required": false,
          "defaultValue": false
        }
      ]
    },
    {
      "id": "safetyqr.report.student_safety_check.v1",
      "displayName": "Student safety check report",
      "headline": "Report a student safety concern",
      "helperText": "Use this template for student medical concerns, personal accidents, theft, or immediate welfare issues without adding vehicle details.",
      "subjectSummary": {
        "title": "Student reports stay category-specific",
        "description": "Capture only the student safety context that matters, especially medical, accident, theft, or welfare concerns."
      },
      "confirmation": {
        "title": "Submit this student safety report?",
        "body": "No OTP is needed before submission. This confirmation only protects against accidental taps.",
        "actionLabel": "Confirm and submit student report"
      },
      "actions": [
        {
          "id": "report_incident",
          "label": "Report Incident",
          "description": "Send the structured student safety report.",
          "submissionMode": "confirm_before_submit",
          "submitLabel": "Review report before sending",
          "fieldIds": [
            "severity",
            "issueType",
            "locationDescription",
            "reporterName",
            "reporterPhone",
            "institutionContext",
            "description",
            "guardianContactRequested",
            "immediateDanger"
          ],
          "requiredFieldIds": [
            "severity",
            "issueType",
            "locationDescription",
            "reporterName",
            "reporterPhone",
            "description"
          ],
          "confirmation": {
            "title": "Submit this student safety report?",
            "body": "No OTP is needed before submission. This confirmation only protects against accidental taps.",
            "actionLabel": "Confirm and submit student report"
          }
        }
      ],
      "media": {
        "allowVoiceNote": true,
        "maxPhotos": 4
      },
      "normalization": {
        "reportKind": "incident",
        "typeFieldId": "issueType",
        "severityFieldId": "severity",
        "locationDescriptionFieldId": "locationDescription",
        "reporterNameFieldId": "reporterName",
        "reporterPhoneFieldId": "reporterPhone",
        "descriptionFieldIds": [
          "institutionContext",
          "description"
        ]
      },
      "fields": [
        {
          "id": "severity",
          "kind": "choice",
          "label": "Urgency",
          "required": true,
          "options": [
            { "label": "Minor", "value": "minor" },
            { "label": "Moderate", "value": "moderate" },
            { "label": "Severe", "value": "severe" },
            { "label": "Critical", "value": "critical" }
          ],
          "defaultValue": ""
        },
        {
          "id": "issueType",
          "kind": "select",
          "label": "Issue type",
          "required": true,
          "helperText": "Choose the closest student concern. Do not enter vehicle details here.",
          "options": [
            { "label": "Select the issue type", "value": "" },
            { "label": "Medical concern", "value": "medical" },
            { "label": "Personal accident or injury", "value": "accident" },
            { "label": "Theft, loss, or tampering", "value": "theft" },
            { "label": "Immediate safety or welfare concern", "value": "hazard" }
          ],
          "defaultValue": ""
        },
        {
          "id": "locationDescription",
          "kind": "text",
          "label": "Current location",
          "required": true,
          "defaultValue": ""
        },
        {
          "id": "reporterName",
          "kind": "text",
          "label": "Your name",
          "required": true,
          "defaultValue": ""
        },
        {
          "id": "reporterPhone",
          "kind": "tel",
          "label": "Your phone",
          "required": true,
          "defaultValue": ""
        },
        {
          "id": "institutionContext",
          "kind": "text",
          "label": "School or institution context",
          "required": false,
          "defaultValue": ""
        },
        {
          "id": "description",
          "kind": "textarea",
          "label": "What happened to the student?",
          "required": true,
          "defaultValue": ""
        },
        {
          "id": "guardianContactRequested",
          "kind": "toggle",
          "label": "A guardian contact request is needed",
          "required": false,
          "defaultValue": false
        },
        {
          "id": "immediateDanger",
          "kind": "toggle",
          "label": "The student appears to be in immediate danger",
          "required": false,
          "defaultValue": false
        }
      ]
    },
    {
      "id": "safetyqr.report.women_safety_assistance.v1",
      "displayName": "Women safety assistance report",
      "headline": "Report a women safety assistance request",
      "helperText": "Use this template for women safety incidents involving medical support, personal accidents, harassment, theft, or an active threat.",
      "subjectSummary": {
        "title": "Women safety reports stay immediate",
        "description": "Capture the location, the current personal safety concern, and the callback path without blocking the report behind OTP."
      },
      "confirmation": {
        "title": "Submit this safety assistance report?",
        "body": "Confirm once, then send the report immediately.",
        "actionLabel": "Confirm and submit safety report"
      },
      "actions": [
        {
          "id": "report_incident",
          "label": "Report Incident",
          "description": "Send the structured women safety assistance report.",
          "submissionMode": "confirm_before_submit",
          "submitLabel": "Review report before sending",
          "fieldIds": [
            "severity",
            "assistanceType",
            "locationDescription",
            "reporterPhone",
            "reporterName",
            "reporterEmail",
            "description",
            "policeAssistanceRequested",
            "emergencyContactAlertRequested"
          ],
          "requiredFieldIds": [
            "severity",
            "assistanceType",
            "locationDescription",
            "reporterPhone",
            "description"
          ],
          "confirmation": {
            "title": "Submit this safety assistance report?",
            "body": "Confirm once, then send the report immediately.",
            "actionLabel": "Confirm and submit safety report"
          }
        }
      ],
      "media": {
        "allowVoiceNote": true,
        "maxPhotos": 4
      },
      "normalization": {
        "reportKind": "incident",
        "typeFieldId": "assistanceType",
        "severityFieldId": "severity",
        "locationDescriptionFieldId": "locationDescription",
        "reporterNameFieldId": "reporterName",
        "reporterPhoneFieldId": "reporterPhone",
        "reporterEmailFieldId": "reporterEmail",
        "descriptionFieldIds": [
          "description"
        ]
      },
      "fields": [
        {
          "id": "severity",
          "kind": "choice",
          "label": "Urgency",
          "required": true,
          "options": [
            { "label": "Minor", "value": "minor" },
            { "label": "Moderate", "value": "moderate" },
            { "label": "Severe", "value": "severe" },
            { "label": "Critical", "value": "critical" }
          ],
          "defaultValue": ""
        },
        {
          "id": "assistanceType",
          "kind": "select",
          "label": "Assistance type",
          "required": true,
          "helperText": "Choose the closest women safety concern. Do not use vehicle-specific details.",
          "options": [
            { "label": "Select the assistance type", "value": "" },
            { "label": "Medical support needed", "value": "medical" },
            { "label": "Personal accident or physical incident", "value": "accident" },
            { "label": "Harassment or stalking concern", "value": "harassment" },
            { "label": "Theft or attempted theft", "value": "theft" },
            { "label": "Unsafe surroundings or active threat", "value": "hazard" }
          ],
          "defaultValue": ""
        },
        {
          "id": "locationDescription",
          "kind": "text",
          "label": "Live location or nearest landmark",
          "required": true,
          "defaultValue": ""
        },
        {
          "id": "reporterPhone",
          "kind": "tel",
          "label": "Callback number",
          "required": true,
          "defaultValue": ""
        },
        {
          "id": "reporterName",
          "kind": "text",
          "label": "Your name",
          "required": false,
          "defaultValue": ""
        },
        {
          "id": "reporterEmail",
          "kind": "email",
          "label": "Your email",
          "required": false,
          "defaultValue": ""
        },
        {
          "id": "description",
          "kind": "textarea",
          "label": "What is happening right now?",
          "required": true,
          "defaultValue": ""
        },
        {
          "id": "policeAssistanceRequested",
          "kind": "toggle",
          "label": "Police help is needed",
          "required": false,
          "defaultValue": false
        },
        {
          "id": "emergencyContactAlertRequested",
          "kind": "toggle",
          "label": "Emergency contacts should be alerted",
          "required": false,
          "defaultValue": false
        }
      ]
    },
    {
      "id": "safetyqr.report.elderly_assistance.v1",
      "displayName": "Elderly assistance report",
      "headline": "Report an elderly assistance request",
      "helperText": "Prioritize medical concerns, falls, theft, or other welfare risks so family or responders can act quickly.",
      "subjectSummary": {
        "title": "Elderly reports prioritize condition and location",
        "description": "Capture the medical, accident, theft, or welfare concern first, then add any supporting context or escalation hints."
      },
      "confirmation": {
        "title": "Submit this elderly assistance report?",
        "body": "No OTP is required before submission. Confirm once and send the report.",
        "actionLabel": "Confirm and submit assistance report"
      },
      "actions": [
        {
          "id": "report_incident",
          "label": "Report Incident",
          "description": "Send the structured elderly assistance report.",
          "submissionMode": "confirm_before_submit",
          "submitLabel": "Review report before sending",
          "fieldIds": [
            "severity",
            "assistanceType",
            "locationDescription",
            "visibleConditionSummary",
            "reporterPhone",
            "reporterName",
            "breathingConsciousnessStatus",
            "fallObserved",
            "ambulanceAlreadyCalled"
          ],
          "requiredFieldIds": [
            "severity",
            "assistanceType",
            "locationDescription",
            "visibleConditionSummary",
            "reporterPhone"
          ],
          "confirmation": {
            "title": "Submit this elderly assistance report?",
            "body": "No OTP is required before submission. Confirm once and send the report.",
            "actionLabel": "Confirm and submit assistance report"
          }
        }
      ],
      "media": {
        "allowVoiceNote": true,
        "maxPhotos": 4
      },
      "normalization": {
        "reportKind": "incident",
        "typeFieldId": "assistanceType",
        "severityFieldId": "severity",
        "locationDescriptionFieldId": "locationDescription",
        "reporterNameFieldId": "reporterName",
        "reporterPhoneFieldId": "reporterPhone",
        "descriptionFieldIds": [
          "visibleConditionSummary"
        ]
      },
      "fields": [
        {
          "id": "severity",
          "kind": "choice",
          "label": "Urgency",
          "required": true,
          "options": [
            { "label": "Minor", "value": "minor" },
            { "label": "Moderate", "value": "moderate" },
            { "label": "Severe", "value": "severe" },
            { "label": "Critical", "value": "critical" }
          ],
          "defaultValue": ""
        },
        {
          "id": "assistanceType",
          "kind": "select",
          "label": "Assistance type",
          "required": true,
          "helperText": "Choose the closest elderly assistance concern. Do not use vehicle-specific details.",
          "options": [
            { "label": "Select the assistance type", "value": "" },
            { "label": "Medical concern", "value": "medical" },
            { "label": "Personal accident or fall", "value": "accident" },
            { "label": "Theft, missing belongings, or tampering", "value": "theft" },
            { "label": "Unsafe environment or welfare risk", "value": "hazard" }
          ],
          "defaultValue": ""
        },
        {
          "id": "locationDescription",
          "kind": "text",
          "label": "Current location",
          "required": true,
          "defaultValue": ""
        },
        {
          "id": "visibleConditionSummary",
          "kind": "textarea",
          "label": "Visible condition or concern",
          "required": true,
          "defaultValue": ""
        },
        {
          "id": "reporterPhone",
          "kind": "tel",
          "label": "Your phone",
          "required": true,
          "defaultValue": ""
        },
        {
          "id": "reporterName",
          "kind": "text",
          "label": "Your name",
          "required": false,
          "defaultValue": ""
        },
        {
          "id": "breathingConsciousnessStatus",
          "kind": "text",
          "label": "Breathing or consciousness notes",
          "required": false,
          "defaultValue": ""
        },
        {
          "id": "fallObserved",
          "kind": "toggle",
          "label": "A fall was observed",
          "required": false,
          "defaultValue": false
        },
        {
          "id": "ambulanceAlreadyCalled",
          "kind": "toggle",
          "label": "An ambulance is already on the way",
          "required": false,
          "defaultValue": false
        }
      ]
    },
    {
      "id": "safetyqr.report.plantations.v1",
      "displayName": "Plantations safety alert and incident report",
      "headline": "Send a plantation safety alert or incident report",
      "helperText": "Use this low-cost, field-ready workflow to flag urgent safety issues across plantation zones. GPS is captured when available, and you can add a voice note or photos without a heavy form.",
      "subjectSummary": {
        "title": "Plantation reports stay deployment-friendly",
        "description": "Capture the issue, the deployment point, and a callback number quickly enough for rural field teams while preserving the plantation/site context."
      },
      "confirmation": {
        "title": "Send this plantation safety report now?",
        "body": "Confirm once to send the report immediately. The same template package is prepared for Panic Alert and Report Incident actions in the next rollout phase.",
        "actionLabel": "Confirm and send plantation report"
      },
      "actions": [
        {
          "id": "panic_alert",
          "label": "Panic Alert",
          "headline": "Send a Plantation panic alert",
          "helperText": "We will attempt GPS immediately and send the alert with one confirmation tap. Photos and a voice note stay optional.",
          "description": "Minimal alert flow for urgent plantation danger or worker distress.",
          "submissionMode": "direct_submit",
          "submitLabel": "Send panic alert",
          "fieldIds": [],
          "requiredFieldIds": [],
          "fieldDefaults": {
            "severity": "critical",
            "issueType": "hazard",
            "description": "Panic alert triggered from this Plantation tag.",
            "policeAssistanceRequested": false,
            "ambulanceRequested": false
          }
        },
        {
          "id": "report_incident",
          "label": "Report Incident",
          "headline": "Send a plantation incident report",
          "helperText": "Capture the zone, issue type, callback details, and optional media in a structured report for the owner and supervisor.",
          "description": "Structured incident report for plantation operations and follow-up.",
          "submissionMode": "confirm_before_submit",
          "submitLabel": "Submit incident report",
          "fieldIds": [
            "severity",
            "issueType",
            "locationDescription",
            "reporterPhone",
            "reporterName",
            "reporterEmail",
            "description",
            "policeAssistanceRequested",
            "ambulanceRequested"
          ],
          "requiredFieldIds": [
            "severity",
            "issueType",
            "locationDescription",
            "reporterPhone",
            "description"
          ],
          "confirmation": {
            "title": "Send this plantation incident report now?",
            "body": "Confirm once to send the structured plantation report immediately.",
            "actionLabel": "Submit incident report"
          }
        }
      ],
      "media": {
        "allowVoiceNote": true,
        "maxPhotos": 4
      },
      "normalization": {
        "reportKind": "incident",
        "typeFieldId": "issueType",
        "severityFieldId": "severity",
        "locationDescriptionFieldId": "locationDescription",
        "reporterNameFieldId": "reporterName",
        "reporterPhoneFieldId": "reporterPhone",
        "reporterEmailFieldId": "reporterEmail",
        "plantationReferenceFieldId": "plantationReference",
        "siteContextFieldId": "siteContext",
        "descriptionFieldIds": [
          "plantationReference",
          "siteContext",
          "description"
        ]
      },
      "fields": [
        {
          "id": "severity",
          "kind": "choice",
          "label": "Urgency",
          "required": true,
          "options": [
            { "label": "Minor", "value": "minor" },
            { "label": "Moderate", "value": "moderate" },
            { "label": "Severe", "value": "severe" },
            { "label": "Critical", "value": "critical" }
          ],
          "defaultValue": ""
        },
        {
          "id": "issueType",
          "kind": "select",
          "label": "Issue type",
          "required": true,
          "options": [
            { "label": "Worker injury or distress", "value": "medical" },
            { "label": "Equipment or power hazard", "value": "hazard" },
            { "label": "Fire or smoke", "value": "fire" },
            { "label": "Wildlife or intruder threat", "value": "theft" },
            { "label": "Vehicle or route blockage", "value": "breakdown" },
            { "label": "Other plantation incident", "value": "accident" }
          ],
          "defaultValue": "hazard"
        },
        {
          "id": "locationDescription",
          "kind": "text",
          "label": "Zone or nearest landmark",
          "required": true,
          "helperText": "Use the field zone name, block marker, road, or nearby landmark if GPS is weak.",
          "defaultValue": ""
        },
        {
          "id": "reporterPhone",
          "kind": "tel",
          "label": "Callback number",
          "required": true,
          "helperText": "Field supervisors can use this if they need a fast follow-up.",
          "defaultValue": ""
        },
        {
          "id": "reporterName",
          "kind": "text",
          "label": "Your name",
          "required": false,
          "defaultValue": ""
        },
        {
          "id": "reporterEmail",
          "kind": "email",
          "label": "Your email",
          "required": false,
          "defaultValue": ""
        },
        {
          "id": "plantationReference",
          "kind": "text",
          "label": "Plantation, card ID, or site reference",
          "required": false,
          "defaultValue": ""
        },
        {
          "id": "siteContext",
          "kind": "text",
          "label": "Site context",
          "required": false,
          "helperText": "Add the estate name, worker line, collection point, or deployment note if it helps responders.",
          "defaultValue": ""
        },
        {
          "id": "description",
          "kind": "textarea",
          "label": "What happened?",
          "required": true,
          "defaultValue": ""
        },
        {
          "id": "policeAssistanceRequested",
          "kind": "toggle",
          "label": "Police or security help is needed",
          "required": false,
          "defaultValue": false
        },
        {
          "id": "ambulanceRequested",
          "kind": "toggle",
          "label": "Medical transport is needed",
          "required": false,
          "defaultValue": false
        }
      ]
    }
  ]
}
